import { render } from "./MonitoringAduan.vue?vue&type=template&id=28d7d99d"
import script from "./MonitoringAduan.vue?vue&type=script&lang=js"
export * from "./MonitoringAduan.vue?vue&type=script&lang=js"

import "./MonitoringAduan.vue?vue&type=style&index=0&id=28d7d99d&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__